import React, { forwardRef, useRef, useState, useEffect, useCallback } from 'react';
import styled, { ThemeProvider, useTheme, css, createGlobalStyle } from 'styled-components';
import { Icon as Icon$1 } from '@mdi/react';
import { mdiLoading, mdiApple, mdiFacebook, mdiGoogle, mdiCheckboxMarked, mdiCheckboxBlankOutline, mdiRadioboxMarked, mdiRadioboxBlank, mdiChevronDown, mdiClose, mdiFormatBold, mdiFormatItalic, mdiFormatListBulleted, mdiFormatListNumbered, mdiUndo, mdiRedo, mdiLightningBolt } from '@mdi/js';
import ReactDOM from 'react-dom';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $convertFromMarkdownString, $convertToMarkdownString, TRANSFORMERS as TRANSFORMERS$1 } from '@lexical/markdown';
import { MarkdownShortcutPlugin } from '@lexical/react/LexicalMarkdownShortcutPlugin';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin';
import { ListPlugin } from '@lexical/react/LexicalListPlugin';
import { $isListNode, ListNode, ListItemNode, INSERT_UNORDERED_LIST_COMMAND, REMOVE_LIST_COMMAND, INSERT_ORDERED_LIST_COMMAND } from '@lexical/list';
import { LinkNode } from '@lexical/link';
import { $getNearestNodeOfType, mergeRegister } from '@lexical/utils';
import { $wrapLeafNodesInElements } from '@lexical/selection';
import { $isHeadingNode, HeadingNode, $createHeadingNode } from '@lexical/rich-text';
import { $getSelection, $isRangeSelection, SELECTION_CHANGE_COMMAND, CAN_UNDO_COMMAND, CAN_REDO_COMMAND, FORMAT_TEXT_COMMAND, UNDO_COMMAND, REDO_COMMAND, $createParagraphNode } from 'lexical';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var lodash_merge = createCommonjsModule(function (module, exports) {
  /**
   * Lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;
  /** Used to stand-in for `undefined` hash values. */

  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  /** Used to detect hot functions by number of calls within a span of milliseconds. */

  var HOT_COUNT = 800,
      HOT_SPAN = 16;
  /** Used as references for various `Number` constants. */

  var MAX_SAFE_INTEGER = 9007199254740991;
  /** `Object#toString` result references. */

  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */

  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  /** Used to detect host constructors (Safari). */

  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  /** Used to detect unsigned integer values. */

  var reIsUint = /^(?:0|[1-9]\d*)$/;
  /** Used to identify `toStringTag` values of typed arrays. */

  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  /** Detect free variable `global` from Node.js. */

  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  /** Detect free variable `self`. */

  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = freeGlobal || freeSelf || Function('return this')();
  /** Detect free variable `exports`. */

  var freeExports =  exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Detect free variable `process` from Node.js. */

  var freeProcess = moduleExports && freeGlobal.process;
  /** Used to access faster Node.js helpers. */

  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      } // Legacy `process.binding('util')` for Node.js < 10.


      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();
  /* Node.js helper references. */


  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */

  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);

      case 1:
        return func.call(thisArg, args[0]);

      case 2:
        return func.call(thisArg, args[0], args[1]);

      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }

    return func.apply(thisArg, args);
  }
  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */


  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }

    return result;
  }
  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */


  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }
  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */


  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */


  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }
  /** Used for built-in method references. */


  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;
  /** Used to detect overreaching core-js shims. */

  var coreJsData = root['__core-js_shared__'];
  /** Used to resolve the decompiled source of functions. */

  var funcToString = funcProto.toString;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /** Used to detect methods masquerading as native. */

  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */


  var nativeObjectToString = objectProto.toString;
  /** Used to infer the `Object` constructor. */

  var objectCtorString = funcToString.call(Object);
  /** Used to detect if a method is native. */

  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  /** Built-in value references. */

  var Buffer = moduleExports ? root.Buffer : undefined,
      Symbol = root.Symbol,
      Uint8Array = root.Uint8Array,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
      getPrototype = overArg(Object.getPrototypeOf, Object),
      objectCreate = Object.create,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      splice = arrayProto.splice,
      symToStringTag = Symbol ? Symbol.toStringTag : undefined;

  var defineProperty = function () {
    try {
      var func = getNative(Object, 'defineProperty');
      func({}, '', {});
      return func;
    } catch (e) {}
  }();
  /* Built-in method references for those with the same name as other `lodash` methods. */


  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
      nativeMax = Math.max,
      nativeNow = Date.now;
  /* Built-in method references that are verified to be native. */

  var Map = getNative(root, 'Map'),
      nativeCreate = getNative(Object, 'create');
  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} proto The object to inherit from.
   * @returns {Object} Returns the new object.
   */

  var baseCreate = function () {
    function object() {}

    return function (proto) {
      if (!isObject(proto)) {
        return {};
      }

      if (objectCreate) {
        return objectCreate(proto);
      }

      object.prototype = proto;
      var result = new object();
      object.prototype = undefined;
      return result;
    };
  }();
  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */


  function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */


  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }
  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function hashGet(key) {
    var data = this.__data__;

    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }

    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }
  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }
  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */


  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  } // Add methods to `Hash`.


  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */


  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }

    var lastIndex = data.length - 1;

    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }

    --this.size;
    return true;
  }
  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
  }
  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */


  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }

    return this;
  } // Add methods to `ListCache`.


  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */


  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }
  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */


  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
        size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  } // Add methods to `MapCache`.


  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }
  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */


  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }
  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function stackDelete(key) {
    var data = this.__data__,
        result = data['delete'](key);
    this.size = data.size;
    return result;
  }
  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function stackGet(key) {
    return this.__data__.get(key);
  }
  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function stackHas(key) {
    return this.__data__.has(key);
  }
  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */


  function stackSet(key, value) {
    var data = this.__data__;

    if (data instanceof ListCache) {
      var pairs = data.__data__;

      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }

      data = this.__data__ = new MapCache(pairs);
    }

    data.set(key, value);
    this.size = data.size;
    return this;
  } // Add methods to `Stack`.


  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */

  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * This function is like `assignValue` except that it doesn't assign
   * `undefined` values.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */


  function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }
  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */


  function assignValue(object, key, value) {
    var objValue = object[key];

    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }
  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */


  function assocIndexOf(array, key) {
    var length = array.length;

    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }

    return -1;
  }
  /**
   * The base implementation of `assignValue` and `assignMergeValue` without
   * value checks.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */


  function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) {
      defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
      });
    } else {
      object[key] = value;
    }
  }
  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */


  var baseFor = createBaseFor();
  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }

    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }
  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */


  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }
  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */


  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }

    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */


  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }
  /**
   * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */


  function baseKeysIn(object) {
    if (!isObject(object)) {
      return nativeKeysIn(object);
    }

    var isProto = isPrototype(object),
        result = [];

    for (var key in object) {
      if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * The base implementation of `_.merge` without support for multiple sources.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} [customizer] The function to customize merged values.
   * @param {Object} [stack] Tracks traversed source values and their merged
   *  counterparts.
   */


  function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
      return;
    }

    baseFor(source, function (srcValue, key) {
      stack || (stack = new Stack());

      if (isObject(srcValue)) {
        baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
      } else {
        var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

        if (newValue === undefined) {
          newValue = srcValue;
        }

        assignMergeValue(object, key, newValue);
      }
    }, keysIn);
  }
  /**
   * A specialized version of `baseMerge` for arrays and objects which performs
   * deep merges and tracks traversed objects enabling objects with circular
   * references to be merged.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {string} key The key of the value to merge.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} mergeFunc The function to merge values.
   * @param {Function} [customizer] The function to customize assigned values.
   * @param {Object} [stack] Tracks traversed source values and their merged
   *  counterparts.
   */


  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key),
        srcValue = safeGet(source, key),
        stacked = stack.get(srcValue);

    if (stacked) {
      assignMergeValue(object, key, stacked);
      return;
    }

    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;

    if (isCommon) {
      var isArr = isArray(srcValue),
          isBuff = !isArr && isBuffer(srcValue),
          isTyped = !isArr && !isBuff && isTypedArray(srcValue);
      newValue = srcValue;

      if (isArr || isBuff || isTyped) {
        if (isArray(objValue)) {
          newValue = objValue;
        } else if (isArrayLikeObject(objValue)) {
          newValue = copyArray(objValue);
        } else if (isBuff) {
          isCommon = false;
          newValue = cloneBuffer(srcValue, true);
        } else if (isTyped) {
          isCommon = false;
          newValue = cloneTypedArray(srcValue, true);
        } else {
          newValue = [];
        }
      } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
        newValue = objValue;

        if (isArguments(objValue)) {
          newValue = toPlainObject(objValue);
        } else if (!isObject(objValue) || isFunction(objValue)) {
          newValue = initCloneObject(srcValue);
        }
      } else {
        isCommon = false;
      }
    }

    if (isCommon) {
      // Recursively merge objects and arrays (susceptible to call stack limits).
      stack.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      stack['delete'](srcValue);
    }

    assignMergeValue(object, key, newValue);
  }
  /**
   * The base implementation of `_.rest` which doesn't validate or coerce arguments.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   */


  function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
  }
  /**
   * The base implementation of `setToString` without support for hot loop shorting.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */


  var baseSetToString = !defineProperty ? identity : function (func, string) {
    return defineProperty(func, 'toString', {
      'configurable': true,
      'enumerable': false,
      'value': constant(string),
      'writable': true
    });
  };
  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */

  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }

    var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }
  /**
   * Creates a clone of `arrayBuffer`.
   *
   * @private
   * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
   * @returns {ArrayBuffer} Returns the cloned array buffer.
   */


  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
  }
  /**
   * Creates a clone of `typedArray`.
   *
   * @private
   * @param {Object} typedArray The typed array to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned typed array.
   */


  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  /**
   * Copies the values of `source` to `array`.
   *
   * @private
   * @param {Array} source The array to copy values from.
   * @param {Array} [array=[]] The array to copy values to.
   * @returns {Array} Returns `array`.
   */


  function copyArray(source, array) {
    var index = -1,
        length = source.length;
    array || (array = Array(length));

    while (++index < length) {
      array[index] = source[index];
    }

    return array;
  }
  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property identifiers to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */


  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1,
        length = props.length;

    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

      if (newValue === undefined) {
        newValue = source[key];
      }

      if (isNew) {
        baseAssignValue(object, key, newValue);
      } else {
        assignValue(object, key, newValue);
      }
    }

    return object;
  }
  /**
   * Creates a function like `_.assign`.
   *
   * @private
   * @param {Function} assigner The function to assign values.
   * @returns {Function} Returns the new assigner function.
   */


  function createAssigner(assigner) {
    return baseRest(function (object, sources) {
      var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : undefined,
          guard = length > 2 ? sources[2] : undefined;
      customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        customizer = length < 3 ? undefined : customizer;
        length = 1;
      }

      object = Object(object);

      while (++index < length) {
        var source = sources[index];

        if (source) {
          assigner(object, source, index, customizer);
        }
      }

      return object;
    });
  }
  /**
   * Creates a base function for methods like `_.forIn` and `_.forOwn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */


  function createBaseFor(fromRight) {
    return function (object, iteratee, keysFunc) {
      var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

      while (length--) {
        var key = props[fromRight ? length : ++index];

        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }

      return object;
    };
  }
  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */


  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }
  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */


  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }
  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */


  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);

    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }

    return result;
  }
  /**
   * Initializes an object clone.
   *
   * @private
   * @param {Object} object The object to clone.
   * @returns {Object} Returns the initialized clone.
   */


  function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
  }
  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */


  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }
  /**
   * Checks if the given arguments are from an iteratee call.
   *
   * @private
   * @param {*} value The potential iteratee value argument.
   * @param {*} index The potential iteratee index or key argument.
   * @param {*} object The potential iteratee object argument.
   * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
   *  else `false`.
   */


  function isIterateeCall(value, index, object) {
    if (!isObject(object)) {
      return false;
    }

    var type = typeof index;

    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
      return eq(object[index], value);
    }

    return false;
  }
  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */


  function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }
  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */


  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */


  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }
  /**
   * This function is like
   * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * except that it includes inherited enumerable properties.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */


  function nativeKeysIn(object) {
    var result = [];

    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */


  function objectToString(value) {
    return nativeObjectToString.call(value);
  }
  /**
   * A specialized version of `baseRest` which transforms the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @param {Function} transform The rest array transform.
   * @returns {Function} Returns the new function.
   */


  function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function () {
      var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);

      while (++index < length) {
        array[index] = args[start + index];
      }

      index = -1;
      var otherArgs = Array(start + 1);

      while (++index < start) {
        otherArgs[index] = args[index];
      }

      otherArgs[start] = transform(array);
      return apply(func, this, otherArgs);
    };
  }
  /**
   * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */


  function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') {
      return;
    }

    if (key == '__proto__') {
      return;
    }

    return object[key];
  }
  /**
   * Sets the `toString` method of `func` to return `string`.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */


  var setToString = shortOut(baseSetToString);
  /**
   * Creates a function that'll short out and invoke `identity` instead
   * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
   * milliseconds.
   *
   * @private
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new shortable function.
   */

  function shortOut(func) {
    var count = 0,
        lastCalled = 0;
    return function () {
      var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;

      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }

      return func.apply(undefined, arguments);
    };
  }
  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */


  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}

      try {
        return func + '';
      } catch (e) {}
    }

    return '';
  }
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */


  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */


  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
  };
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */

  var isArray = Array.isArray;
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */

  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */


  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */


  var isBuffer = nativeIsBuffer || stubFalse;
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */

  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    } // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.


    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */


  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */


  function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */


  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }
  /**
   * Checks if `value` is a plain object, that is, an object created by the
   * `Object` constructor or one with a `[[Prototype]]` of `null`.
   *
   * @static
   * @memberOf _
   * @since 0.8.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * _.isPlainObject(new Foo);
   * // => false
   *
   * _.isPlainObject([1, 2, 3]);
   * // => false
   *
   * _.isPlainObject({ 'x': 0, 'y': 0 });
   * // => true
   *
   * _.isPlainObject(Object.create(null));
   * // => true
   */


  function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
      return false;
    }

    var proto = getPrototype(value);

    if (proto === null) {
      return true;
    }

    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
  }
  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */


  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  /**
   * Converts `value` to a plain object flattening inherited enumerable string
   * keyed properties of `value` to own properties of the plain object.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {Object} Returns the converted plain object.
   * @example
   *
   * function Foo() {
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.assign({ 'a': 1 }, new Foo);
   * // => { 'a': 1, 'b': 2 }
   *
   * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
   * // => { 'a': 1, 'b': 2, 'c': 3 }
   */

  function toPlainObject(value) {
    return copyObject(value, keysIn(value));
  }
  /**
   * Creates an array of the own and inherited enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keysIn(new Foo);
   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
   */


  function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
  }
  /**
   * This method is like `_.assign` except that it recursively merges own and
   * inherited enumerable string keyed properties of source objects into the
   * destination object. Source properties that resolve to `undefined` are
   * skipped if a destination value exists. Array and plain object properties
   * are merged recursively. Other objects and value types are overridden by
   * assignment. Source objects are applied from left to right. Subsequent
   * sources overwrite property assignments of previous sources.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 0.5.0
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @example
   *
   * var object = {
   *   'a': [{ 'b': 2 }, { 'd': 4 }]
   * };
   *
   * var other = {
   *   'a': [{ 'c': 3 }, { 'e': 5 }]
   * };
   *
   * _.merge(object, other);
   * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
   */


  var merge = createAssigner(function (object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
  });
  /**
   * Creates a function that returns `value`.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {*} value The value to return from the new function.
   * @returns {Function} Returns the new constant function.
   * @example
   *
   * var objects = _.times(2, _.constant({ 'a': 1 }));
   *
   * console.log(objects);
   * // => [{ 'a': 1 }, { 'a': 1 }]
   *
   * console.log(objects[0] === objects[1]);
   * // => true
   */

  function constant(value) {
    return function () {
      return value;
    };
  }
  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */


  function identity(value) {
    return value;
  }
  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */


  function stubFalse() {
    return false;
  }

  module.exports = merge;
});

const regular = 500;
const bold = 600;
const remCalc = (val, base) => `${val / base}rem`;
const remCalcWithTheme = val => ({
  theme
}) => remCalc(val, theme.base);
const color = {
  White: "#FFF",
  // Primary
  Primary: "#2D6AEF",
  LightPrimary: "#D9E6FF",
  VeryLightPrimary: "#EFF5FF",
  DarkPrimary: "#0D42B6",
  VeryDarkPrimary: "#08286F",
  // Secondary
  Secondary: "#F89056",
  LightSecondary: "#FFEEDE",
  VeryLightSecondary: "#FFF7EF",
  DarkSecondary: "#E7712F",
  VeryDarkSecondary: "#AA3F31",
  // Grey
  DarkGrey: "#37393C",
  Grey: "#6D7076",
  LightGrey: "#C2C8D6",
  VeryLightGrey: "#F2F4F8",
  // Secondary
  Red: "#FB8288",
  LightRed: "#FFE9EA",
  DarkRed: "#CE5157",
  Amber: "#FFD747",
  LightAmber: "#FFF8E0",
  DarkAmber: "#CDA205",
  Green: "#63D683",
  LightGreen: "#E8FDEE",
  DarkGreen: "#138B35",
  // Social
  Facebook: "#1877F2",
  Apple: "#000"
};
const typography = {
  base: {
    fontFamily: `"Avenir Next", "Avenir", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
    "Helvetica Neue", sans-serif`
  },
  Display: {
    fontSize: remCalcWithTheme(36),
    fontWeight: bold,
    lineHeight: remCalcWithTheme(44),
    textTransform: "none"
  },
  Title1: {
    fontSize: remCalcWithTheme(26),
    fontWeight: bold,
    lineHeight: remCalcWithTheme(32),
    textTransform: "none"
  },
  Title2: {
    fontSize: remCalcWithTheme(20),
    fontWeight: bold,
    lineHeight: remCalcWithTheme(28)
  },
  Headline: {
    fontSize: remCalcWithTheme(14),
    fontWeight: bold,
    lineHeight: remCalcWithTheme(20)
  },
  Subhead: {
    fontSize: remCalcWithTheme(12),
    fontWeight: bold,
    lineHeight: remCalcWithTheme(16)
  },
  Callout: {
    fontSize: remCalcWithTheme(18),
    fontWeight: regular,
    lineHeight: remCalcWithTheme(24)
  },
  Body: {
    fontSize: remCalcWithTheme(14),
    fontWeight: regular,
    lineHeight: remCalcWithTheme(20)
  },
  Action: {
    fontSize: remCalcWithTheme(14),
    fontWeight: bold,
    lineHeight: remCalcWithTheme(20)
  },
  Caption: {
    fontSize: remCalcWithTheme(12),
    fontWeight: regular,
    lineHeight: remCalcWithTheme(16)
  },
  Footnote: {
    fontSize: remCalcWithTheme(10),
    fontWeight: regular,
    lineHeight: remCalcWithTheme(16)
  }
};
const button = {
  base: {
    borderRadius: "8px",
    padding: "8px 16px",
    socialButtonPadding: "8px 40px",
    textTransform: "none",
    fontSize: typography.Action.fontSize,
    fontWeight: typography.Action.fontWeight,
    height: remCalcWithTheme(40)
  },
  primary: {
    backgroundColor: {
      active: color.Primary,
      disabled: color.LightPrimary,
      loading: color.LightPrimary,
      hover: color.DarkPrimary
    },
    border: {
      active: `2px solid ${color.Primary}`,
      disabled: `2px solid ${color.LightPrimary}`,
      loading: `2px solid ${color.LightPrimary}`,
      hover: `2px solid ${color.DarkPrimary}`
    },
    textColor: {
      active: color.White,
      disabled: color.White,
      loading: "transparent"
    }
  },
  secondary: {
    backgroundColor: {
      active: color.White,
      disabled: color.VeryLightGrey,
      loading: color.VeryLightGrey,
      hover: color.VeryLightGrey
    },
    border: {
      active: `2px solid ${color.VeryLightGrey}`,
      disabled: `2px solid ${color.VeryLightGrey}`,
      loading: `2px solid ${color.VeryLightGrey}`,
      hover: `2px solid ${color.VeryLightGrey}`
    },
    textColor: {
      active: color.DarkGrey,
      disabled: color.LightGrey,
      loading: "transparent"
    }
  },
  warning: {
    backgroundColor: {
      active: color.White,
      disabled: color.LightRed,
      loading: color.LightRed,
      hover: color.LightRed
    },
    border: {
      active: `2px solid ${color.LightRed}`,
      disabled: `2px solid ${color.LightRed}`,
      loading: `2px solid ${color.LightRed}`,
      hover: `2px solid ${color.LightRed}`
    },
    textColor: {
      active: color.DarkGrey,
      disabled: color.White,
      loading: "transparent"
    }
  },
  destructive: {
    backgroundColor: {
      active: color.DarkRed,
      disabled: color.LightRed,
      loading: color.LightRed,
      hover: color.Red
    },
    border: {
      active: `2px solid ${color.DarkRed}`,
      disabled: `2px solid ${color.LightRed}`,
      loading: `2px solid ${color.LightRed}`,
      hover: `2px solid ${color.Red}`
    },
    textColor: {
      active: color.White,
      disabled: color.White,
      loading: "transparent"
    }
  },
  facebook: {
    backgroundColor: {
      active: color.White,
      disabled: color.VeryLightGrey,
      loading: color.VeryLightGrey,
      hover: color.VeryLightGrey
    },
    border: {
      active: `2px solid ${color.VeryLightGrey}`,
      disabled: `2px solid ${color.VeryLightGrey}`,
      loading: `2px solid ${color.VeryLightGrey}`,
      hover: `2px solid ${color.VeryLightGrey}`
    },
    textColor: {
      active: color.DarkGrey,
      disabled: color.LightGrey,
      loading: "transparent"
    }
  },
  google: {
    backgroundColor: {
      active: color.White,
      disabled: color.VeryLightGrey,
      loading: color.VeryLightGrey,
      hover: color.VeryLightGrey
    },
    border: {
      active: `2px solid ${color.VeryLightGrey}`,
      disabled: `2px solid ${color.VeryLightGrey}`,
      loading: `2px solid ${color.VeryLightGrey}`,
      hover: `2px solid ${color.VeryLightGrey}`
    },
    textColor: {
      active: color.DarkGrey,
      disabled: color.LightGrey,
      loading: "transparent"
    }
  },
  apple: {
    backgroundColor: {
      active: color.Apple,
      disabled: color.DarkGrey,
      loading: color.DarkGrey,
      hover: color.DarkGrey
    },
    border: {
      active: `2px solid ${color.Apple}`,
      disabled: `2px solid ${color.DarkGrey}`,
      loading: `2px solid ${color.DarkGrey}`,
      hover: `2px solid ${color.DarkGrey}`
    },
    textColor: {
      active: color.White,
      disabled: color.LightGrey,
      loading: "transparent"
    }
  },
  radio: {
    backgroundColor: {
      active: color.White,
      disabled: color.White,
      selected: color.LightPrimary,
      unselected: color.White,
      hover: color.VeryLightGrey,
      removable: color.White
    },
    border: {
      active: `2px solid ${color.VeryLightGrey}`,
      disabled: "2px solid transparent",
      selected: "2px solid transparent",
      unselected: `2px solid ${color.VeryLightGrey}`,
      hover: "2px solid transparent",
      removable: `2px solid ${color.VeryLightGrey}`
    },
    padding: {
      default: "8px 12px 8px 8px",
      fullWidth: "8px 12px"
    }
  },
  checkbox: {
    backgroundColor: {
      disabled: color.White,
      selected: color.LightPrimary,
      unselected: color.White
    },
    border: {
      disabled: "2px solid transparent",
      selected: "2px solid transparent",
      unselected: `2px solid ${color.VeryLightGrey}`
    }
  }
};
const card = {
  base: {
    padding: remCalcWithTheme(24),
    borderRadius: remCalcWithTheme(8)
  },
  default: {
    backgroundColor: color.White
  },
  outline: {
    backgroundColor: color.White,
    borderWidth: "2px",
    borderColor: color.VeryLightGrey
  },
  grey: {
    backgroundColor: color.VeryLightGrey
  }
};
const form = {
  input: {
    borderRadius: remCalcWithTheme(4),
    height: remCalcWithTheme(40),
    border: {
      default: `1px solid ${color.LightGrey}`,
      focus: `2px solid ${color.Primary}`
    },
    padding: {
      default: "8px 12px",
      focus: "7px 11px",
      select: "9px 12px 10px",
      selectFocus: "8px 11px 9px"
    }
  }
};
const pill = {
  base: {
    borderRadius: "4px",
    padding: "4px 8px",
    textTransform: "none",
    fontSize: typography.Body.fontSize,
    fontWeight: typography.Body.fontWeight,
    backgroundColor: color.LightPrimary,
    textColor: color.DarkGrey
  },
  neutral: {
    backgroundColor: color.VeryLightGrey,
    textColor: color.DarkGrey
  },
  member: {
    backgroundColor: color.Primary,
    textColor: color.White
  },
  positive: {
    backgroundColor: color.LightGreen,
    textColor: color.DarkGrey
  },
  negative: {
    backgroundColor: color.LightRed,
    textColor: color.DarkGrey
  },
  warning: {
    backgroundColor: color.LightAmber,
    textColor: color.DarkGrey
  }
};
const media = {
  xxsmall: "360px",
  xsmall: "560px",
  small: "766px",
  medium: "1165px",
  large: "1300px"
};
const theme = {
  base: 14,
  chameleon: {
    button,
    card,
    color,
    form,
    media,
    typography,
    pill
  }
};
const ChameleonProvider = props => {
  var _props$theme, _props$theme2;

  if ((_props$theme = props.theme) !== null && _props$theme !== void 0 && _props$theme.chameleon) {
    throw new Error("Overwriting the Chameleon theme is not allowed, use DangerousChameleonProvider instead!");
  }

  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: { ...theme,
      ...((_props$theme2 = props.theme) !== null && _props$theme2 !== void 0 ? _props$theme2 : {})
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "chameleon-portal"
  }), props.children);
};
const DangerousChameleonProvider = props => {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: lodash_merge({}, theme, props.theme)
  }, /*#__PURE__*/React.createElement("div", {
    id: "chameleon-portal"
  }), props.children);
};
const useChameleonTheme = useTheme;

const ContainerBase = css(["box-sizing:border-box;display:flex;position:relative;flex:1;", ";", ";"], ({
  withPadding
}) => withPadding && `padding: 24px;`, ({
  marginBottomSize
}) => // Converts marginBottomSize={1} into 8px in rem, e.g. 8px = 0.571428571rem
marginBottomSize && `
    margin-bottom: ${marginBottomSize * 0.571428571}rem;
  }`);
const FlexRow = styled.div`
  ${ContainerBase};
  flex-direction: row;
`;
const FlexColumn = styled.div`
  ${ContainerBase};
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
`;
const FlexCenter = styled.div`
  ${ContainerBase};
  place-items: center;
  place-content: center;
`;

const Icon = ({
  path,
  size = 24,
  rotate = 0,
  color: color$1 = color.DarkGrey,
  spin,
  disabled,
  style
}) => {
  const {
    base
  } = useChameleonTheme();
  return /*#__PURE__*/React.createElement(Icon$1, {
    path: path,
    size: remCalc(size, base),
    rotate: rotate,
    color: color$1,
    spin: spin,
    style: disabled ? {
      opacity: 0.3,
      ...style
    } : style
  });
};

const baseTypography = css(["font-family:", ";height:min-content;margin:0;", ";"], ({
  theme
}) => theme.chameleon.typography.base.fontFamily, ({
  marginBottomSize
}) => // Converts marginBottomSize={1} into 8px in rem, e.g. 8px = 0.571428571rem
marginBottomSize && `
    margin-bottom: ${marginBottomSize * 0.571428571}rem;
  }`);
const Display = styled.h1.attrs(props => {
  var _props$marginBottomSi;

  return {
    marginBottomSize: (_props$marginBottomSi = props.marginBottomSize) !== null && _props$marginBottomSi !== void 0 ? _props$marginBottomSi : 3
  };
})`
  ${baseTypography};
  color: ${({
  textColor,
  theme
}) => textColor || theme.chameleon.color.DarkGrey};
  font-size: ${({
  theme
}) => theme.chameleon.typography.Display.fontSize};
  font-weight: ${({
  theme
}) => theme.chameleon.typography.Display.fontWeight};
  line-height: ${({
  theme
}) => theme.chameleon.typography.Display.lineHeight};
`;
const Title1 = styled.h1.attrs(props => {
  var _props$marginBottomSi2;

  return {
    marginBottomSize: (_props$marginBottomSi2 = props.marginBottomSize) !== null && _props$marginBottomSi2 !== void 0 ? _props$marginBottomSi2 : 3
  };
})`
  ${baseTypography};
  color: ${({
  textColor,
  theme
}) => textColor || theme.chameleon.color.DarkGrey};
  font-size: ${({
  theme
}) => theme.chameleon.typography.Title1.fontSize};
  font-weight: ${({
  theme
}) => theme.chameleon.typography.Title1.fontWeight};
  line-height: ${({
  theme
}) => theme.chameleon.typography.Title1.lineHeight};
`;
const Title2 = styled.h2.attrs(props => ({
  marginBottomSize: props.marginBottomSize || props.marginBottomSize === undefined && 3
}))`
  ${baseTypography};
  color: ${({
  textColor,
  theme
}) => textColor || theme.chameleon.color.DarkGrey};
  font-size: ${({
  theme
}) => theme.chameleon.typography.Title2.fontSize};
  font-weight: ${({
  theme
}) => theme.chameleon.typography.Title2.fontWeight};
  line-height: ${({
  theme
}) => theme.chameleon.typography.Title2.lineHeight};
`;
const Headline = styled.p.attrs(props => {
  var _props$marginBottomSi3;

  return {
    marginBottomSize: (_props$marginBottomSi3 = props.marginBottomSize) !== null && _props$marginBottomSi3 !== void 0 ? _props$marginBottomSi3 : 1
  };
})`
  ${baseTypography};
  color: ${({
  textColor,
  theme
}) => textColor || theme.chameleon.color.DarkGrey};
  font-size: ${({
  theme
}) => theme.chameleon.typography.Headline.fontSize};
  font-weight: ${({
  theme
}) => theme.chameleon.typography.Headline.fontWeight};
  line-height: ${({
  theme
}) => theme.chameleon.typography.Headline.lineHeight};
`;
const Subhead = styled.p.attrs(props => {
  var _props$marginBottomSi4;

  return {
    marginBottomSize: (_props$marginBottomSi4 = props.marginBottomSize) !== null && _props$marginBottomSi4 !== void 0 ? _props$marginBottomSi4 : 2
  };
})`
  ${baseTypography};
  color: ${({
  textColor,
  theme
}) => textColor || theme.chameleon.color.DarkGrey};
  font-size: ${({
  theme
}) => theme.chameleon.typography.Subhead.fontSize};
  font-weight: ${({
  theme
}) => theme.chameleon.typography.Subhead.fontWeight};
  line-height: ${({
  theme
}) => theme.chameleon.typography.Subhead.lineHeight};
`;
const Callout = styled.p.attrs(props => {
  var _props$marginBottomSi5;

  return {
    marginBottomSize: (_props$marginBottomSi5 = props.marginBottomSize) !== null && _props$marginBottomSi5 !== void 0 ? _props$marginBottomSi5 : 2
  };
})`
  ${baseTypography};
  color: ${({
  textColor,
  theme
}) => textColor || theme.chameleon.color.DarkGrey};
  font-size: ${({
  theme
}) => theme.chameleon.typography.Callout.fontSize};
  font-weight: ${({
  theme
}) => theme.chameleon.typography.Callout.fontWeight};
  line-height: ${({
  theme
}) => theme.chameleon.typography.Callout.lineHeight};
`;
const Body = styled.p.attrs(props => {
  var _props$marginBottomSi6;

  return {
    marginBottomSize: (_props$marginBottomSi6 = props.marginBottomSize) !== null && _props$marginBottomSi6 !== void 0 ? _props$marginBottomSi6 : 2
  };
})`
  ${baseTypography};
  color: ${({
  textColor,
  theme
}) => textColor || theme.chameleon.color.Grey};
  font-size: ${({
  theme
}) => theme.chameleon.typography.Body.fontSize};
  font-weight: ${({
  theme
}) => theme.chameleon.typography.Body.fontWeight};
  line-height: ${({
  theme
}) => theme.chameleon.typography.Body.lineHeight};
`;
const Action = styled.p.attrs(props => ({
  marginBottomSize: props.marginBottomSize
}))`
  ${baseTypography};
  color: ${({
  textColor,
  theme
}) => textColor || theme.chameleon.color.DarkGrey};
  font-size: ${({
  theme
}) => theme.chameleon.typography.Action.fontSize};
  font-weight: ${({
  theme
}) => theme.chameleon.typography.Action.fontWeight};
  line-height: ${({
  theme
}) => theme.chameleon.typography.Action.lineHeight};
`;
const Caption = styled.p.attrs(props => {
  var _props$marginBottomSi7;

  return {
    marginBottomSize: (_props$marginBottomSi7 = props.marginBottomSize) !== null && _props$marginBottomSi7 !== void 0 ? _props$marginBottomSi7 : 2
  };
})`
  ${baseTypography};
  color: ${({
  textColor,
  theme
}) => textColor || theme.chameleon.color.Grey};
  font-size: ${({
  theme
}) => theme.chameleon.typography.Caption.fontSize};
  font-weight: ${({
  theme
}) => theme.chameleon.typography.Caption.fontWeight};
  line-height: ${({
  theme
}) => theme.chameleon.typography.Caption.lineHeight};
`;
const Footnote = styled.p.attrs(props => {
  var _props$marginBottomSi8;

  return {
    marginBottomSize: (_props$marginBottomSi8 = props.marginBottomSize) !== null && _props$marginBottomSi8 !== void 0 ? _props$marginBottomSi8 : 2
  };
})`
  ${baseTypography};
  color: ${({
  textColor,
  theme
}) => textColor || theme.chameleon.color.Grey};
  font-size: ${({
  theme
}) => theme.chameleon.typography.Footnote.fontSize};
  font-weight: ${({
  theme
}) => theme.chameleon.typography.Footnote.fontWeight};
  line-height: ${({
  theme
}) => theme.chameleon.typography.Footnote.lineHeight};
`;

const InputFieldBase = css(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";border:", ";border-radius:", ";color:", ";margin:0;margin-bottom:", ";min-height:", ";min-width:", ";max-width:100%;width:fill-available;padding:", ";", " ", " ", " ", ""], ({
  theme
}) => theme.chameleon.typography.base.fontFamily, ({
  theme
}) => theme.chameleon.typography.Body.fontSize, ({
  theme
}) => theme.chameleon.typography.Body.fontWeight, ({
  theme
}) => theme.chameleon.typography.Body.lineHeight, ({
  theme
}) => theme.chameleon.form.input.border.default, ({
  theme
}) => theme.chameleon.form.input.borderRadius, ({
  theme
}) => theme.chameleon.color.DarkGrey, remCalcWithTheme(8), remCalcWithTheme(22), remCalcWithTheme(80), ({
  theme
}) => theme.chameleon.form.input.padding.default, ({
  disabled,
  theme
}) => disabled && `
    background-color: ${theme.chameleon.color.VeryLightGrey};
  `, ({
  error,
  theme
}) => error && `
    border: 1px solid ${theme.chameleon.color.DarkRed};
  `, ({
  suffix
}) => // Prevents input value and native browser UI overlapping suffix
suffix && `
    padding-right: calc(20px + ${suffix.length}ch);
  `, ({
  prefix
}) => // Prevents input value and native browser UI overlapping suffix
prefix && `
    padding-left: calc(20px + ${prefix.length}ch);
  `);
const TextAreaField = styled.textarea`
  ${InputFieldBase};
  outline: none;

  :focus {
    border: ${({
  theme
}) => theme.chameleon.form.input.border.focus};
    padding: ${({
  theme
}) => theme.chameleon.form.input.padding.focus};
  }

  /* smartphones, touchscreens */
  /* A catch all rule to prevent iOS devices zooming in on focus */
  @media (hover: none) and (pointer: coarse) {
    font-size: ${remCalcWithTheme(16)};
  }
`;
const InputField = styled.input`
  ${InputFieldBase};
  outline: none;

  :focus {
    border: ${({
  theme
}) => theme.chameleon.form.input.border.focus};
    padding: ${({
  theme
}) => theme.chameleon.form.input.padding.focus};

    ${({
  suffix
}) => // Prevents input value and native browser UI overlapping suffix
suffix && `
    padding-right: calc(19px + ${suffix.length}ch);
  `}

    ${({
  prefix
}) => // Prevents input value and native browser UI overlapping suffix
prefix && `
    padding-left: calc(19px + ${prefix.length}ch);
  `}
  }

  /* smartphones, touchscreens */
  /* A catch all rule to prevent iOS devices zooming in on focus */
  @media (hover: none) and (pointer: coarse) {
    font-size: ${remCalcWithTheme(16)};
  }
`;
const InputFieldButton = styled.button`
  ${InputFieldBase};
  background-color: ${({
  theme
}) => theme.chameleon.color.White};
  cursor: pointer;
  outline-color: ${({
  theme
}) => theme.chameleon.color.Primary};
  text-align: left;
`;
const AffixBase = css(["align-items:center;border:1px solid transparent;color:", ";display:flex;overflow:visible;padding:", ";pointer-events:none;position:absolute;top:0;"], ({
  theme
}) => theme.chameleon.color.DarkGrey, ({
  theme
}) => theme.chameleon.form.input.padding.default);
const Suffix = styled(Body).attrs(() => ({
  as: "span"
}))`
  align-self: flex-end;
  ${AffixBase};
`;
const PhoneNumberPrefix = styled(Body).attrs(() => ({
  as: "span"
}))`
  align-self: flex-start;
  ${AffixBase};
`;
const Prefix = styled(Body).attrs(() => ({
  as: "span"
}))`
  ${AffixBase};
  align-self: flex-start;
  background-color: ${({
  theme
}) => theme.chameleon.color.VeryLightGrey};
  border-color: ${({
  theme
}) => theme.chameleon.color.LightGrey};
  border-radius: ${({
  theme
}) => theme.chameleon.form.input.borderRadius};
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;
const StyledInputWrapper = styled(FlexColumn)`
  height: fit-content;
  margin-bottom: ${remCalcWithTheme(16)};

  ${({
  maxWidth
}) => maxWidth && `
      max-width: ${maxWidth};
    `};
`;
const InputLabelAndHint = ({
  id,
  label,
  hint
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement(Headline, {
    as: "label",
    htmlFor: id
  }, label), hint && /*#__PURE__*/React.createElement(Body, {
    marginBottomSize: 1
  }, hint));
};
const InputError = ({
  error
}) => {
  return /*#__PURE__*/React.createElement(Body, {
    textColor: color.DarkRed,
    marginBottomSize: 1
  }, error);
};

const LimitCounter = ({
  max,
  currentLength
}) => {
  const {
    chameleon
  } = useChameleonTheme();
  const {
    Green,
    DarkAmber,
    DarkRed
  } = chameleon.color;
  const pc = currentLength / max * 100;
  const textColor = pc < 85 ? Green : pc < 100 ? DarkAmber : DarkRed;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 2,
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React.createElement(Body, {
    marginBottomSize: 1,
    textColor: textColor
  }, currentLength, "/", max));
};

const InputWrapper = ({
  label,
  hint,
  suffix,
  iconRight,
  error,
  children,
  maxWidth,
  id,
  style,
  prefix,
  maxLength,
  currentLength
}) => {
  return /*#__PURE__*/React.createElement(StyledInputWrapper, {
    maxWidth: maxWidth,
    style: style
  }, /*#__PURE__*/React.createElement(InputLabelAndHint, {
    id: id,
    hint: hint,
    label: label
  }), /*#__PURE__*/React.createElement(FlexColumn, null, prefix && /*#__PURE__*/React.createElement(Prefix, null, prefix), children, suffix && /*#__PURE__*/React.createElement(Suffix, null, suffix), iconRight && /*#__PURE__*/React.createElement(Suffix, {
    as: "div"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 18,
    path: iconRight
  }))), /*#__PURE__*/React.createElement(FlexRow, {
    style: {
      justifyContent: "space-between",
      gap: "2rem"
    }
  }, error ? /*#__PURE__*/React.createElement(InputError, {
    error: error
  }) : null, maxLength != null && currentLength != null ? /*#__PURE__*/React.createElement(LimitCounter, {
    currentLength: currentLength,
    max: maxLength
  }) : null));
};

const Color = {
  carrot: theme.chameleon.color.Secondary,
  emerald: theme.chameleon.color.Green,
  peterRiver: theme.chameleon.color.DarkPrimary,
  burntUmber: theme.chameleon.color.DarkSecondary,
  alizarin: theme.chameleon.color.DarkRed,
  turquoise: theme.chameleon.color.DarkGreen,
  midnightBlue: theme.chameleon.color.VeryDarkPrimary
};

const renderInitials = name => {
  const allNames = name.toUpperCase().split(" ");
  const firstName = allNames[0];
  const lastName = allNames.length > 1 ? allNames[allNames.length - 1] : undefined;

  if (!lastName) {
    return firstName[0];
  }

  return firstName[0] + lastName[0];
};

const renderColor = name => {
  let sumChars = 0;

  for (let i = 0; i < name.length; i += 1) {
    sumChars += name.charCodeAt(i);
  }

  const colors = Object.values(Color);
  return colors[sumChars % colors.length];
};

const getAvatarSize = (theme, size) => {
  switch (size) {
    case "large":
      return remCalc(80, theme.base);

    case "jumbo":
      return remCalc(200, theme.base);

    case "medium":
      return remCalc(56, theme.base);

    default:
      return theme.chameleon.button.base.height;
  }
};

const Avatar = styled(FlexCenter)`
  ${({
  user,
  theme
}) => {
  if (!user) {
    return `background-color: ${theme.chameleon.color.LightGrey}`;
  }

  if (user.avatar) {
    return `
      background-image: url(${user.avatar});
      background-size: cover;
      background-position: center;`;
  }

  if (user.name) {
    return `background-color: ${renderColor(user.name)}`;
  }
}};
  border-radius: 200px;
  flex: none;
  min-height: ${({
  size,
  theme
}) => getAvatarSize(theme, size)};
  height: ${({
  size,
  theme
}) => getAvatarSize(theme, size)};
  min-width: ${({
  size,
  theme
}) => getAvatarSize(theme, size)};
  width: ${({
  size,
  theme
}) => getAvatarSize(theme, size)};

  &::before {
    content: ${({
  user
}) => {
  if (user && user.name && !user.avatar) {
    return `"${renderInitials(user.name)}"`;
  }

  return "";
}};
    font-family: ${({
  theme
}) => theme.chameleon.typography.base.fontFamily};
    font-size: ${({
  size,
  theme
}) => {
  switch (size) {
    case "medium":
      return theme.chameleon.typography.Title2.fontSize;

    case "large":
      return theme.chameleon.typography.Title1.fontSize;

    case "jumbo":
      return remCalc(64, theme.base);

    default:
      return theme.chameleon.typography.Action.fontSize;
  }
}};
    font-weight: ${({
  theme
}) => theme.chameleon.typography.Action.fontWeight};
    color: ${({
  theme
}) => theme.chameleon.color.White};
  }
`;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

const baseCss = css(["font-size:", ";font-weight:", ";font-family:", ";min-height:", ";width:", ";min-width:fit-content;display:block;height:min-content;margin:0;outline-offset:-4px;position:relative;", " ", ";", ""], ({
  theme
}) => theme.chameleon.button.base.fontSize, ({
  theme
}) => theme.chameleon.button.base.fontWeight, ({
  theme
}) => theme.chameleon.typography.base.fontFamily, ({
  theme
}) => theme.chameleon.button.base.height, ({
  width
}) => width ? width : "fit-content", ({
  theme,
  variant,
  state = "active"
}) => `
    background-color: ${theme.chameleon.button[variant].backgroundColor[state]};
    border: ${theme.chameleon.button[variant].border[state]};
    border-radius: ${theme.chameleon.button.base.borderRadius};
    color: ${theme.chameleon.button[variant].textColor[state]};
    cursor: ${state === "active" ? "pointer" : "default"};
    outline-color: ${theme.chameleon.color.Primary};
    padding: ${theme.chameleon.button.base.padding};
    text-transform: ${theme.chameleon.button.base.textTransform};
    transition: all ease-out 300ms;
  `, ({
  state,
  theme,
  variant
}) => state === "active" && `
  &:hover {
    background-color: ${theme.chameleon.button[variant].backgroundColor.hover};
    border: ${theme.chameleon.button[variant].border.hover};
  }
`, ({
  variant,
  theme
}) => ["facebook", "google", "apple"].includes(variant) && `
  padding: ${theme.chameleon.button.base.socialButtonPadding};
  
  @media (min-width: ${media.xxsmall}) {
    padding-right: 16px;
  }

`);
const StyledButton = styled.button`
  ${baseCss}
`;
const StyledAnchor = styled.a`
  ${baseCss}
  text-decoration: none;
`;
const IconContainer = styled.div`
  position: absolute;
  align-items: center;
  display: flex;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  ${({
  align
}) => align && `place-items: ${align}`};
`;

const Base = ({
  state,
  variant,
  children
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, children, state === "loading" && /*#__PURE__*/React.createElement(IconContainer, {
    style: {
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    path: mdiLoading,
    spin: 0.5,
    size: 18,
    color: ["secondary", "facebook", "google"].includes(variant) ? color.LightGrey : color.White
  })), ["apple", "facebook", "google"].includes(variant) && /*#__PURE__*/React.createElement(IconContainer, {
    align: state === "loading" ? "center" : undefined,
    style: {
      paddingLeft: state === "loading" ? "0" : "12px"
    }
  }, variant === "apple" && state !== "loading" && /*#__PURE__*/React.createElement(Icon, {
    path: mdiApple,
    size: 20,
    color: state === "disabled" ? color.LightGrey : color.White,
    style: {
      marginBottom: 4
    }
  }), variant === "facebook" && state !== "loading" && /*#__PURE__*/React.createElement(Icon, {
    path: mdiFacebook,
    size: 22,
    color: state === "disabled" ? color.LightGrey : color.Facebook
  }), variant === "google" && state !== "loading" && /*#__PURE__*/React.createElement(Icon, {
    path: mdiGoogle,
    size: 18,
    color: state === "disabled" ? color.LightGrey : color.Grey
  })));
};

const Button = ({
  state = "active",
  variant,
  children,
  ...props
}) => /*#__PURE__*/React.createElement(StyledButton, _extends({}, props, {
  variant: variant,
  state: state,
  disabled: state === "disabled" || state === "loading",
  "aria-label": state === "loading" ? "Loading" : undefined,
  type: props.type,
  width: props.width,
  onClick: props.onClick
}), /*#__PURE__*/React.createElement(Base, {
  state: state,
  variant: variant,
  children: children
}));

const ButtonLink = ({
  state = "active",
  children,
  variant,
  width,
  ...props
}) => /*#__PURE__*/React.createElement(StyledAnchor, _extends({}, props, {
  variant: variant,
  state: state,
  "aria-label": state === "loading" ? "Loading" : undefined,
  width: width
}), /*#__PURE__*/React.createElement(Base, {
  children: children,
  variant: variant,
  state: state
}));

const StyledAction = styled(Action).attrs(() => ({
  as: "label"
}))`
  ${({
  state = "unselected",
  theme
}) => {
  return [`align-items: center;
      border-radius: ${theme.chameleon.button.base.borderRadius};
      cursor: ${state === "disabled" ? "default" : "pointer"};
      display: flex;
      justify-content: space-between;
      outline-color: ${theme.chameleon.color.Primary};
      outline-offset: -4px;
      position: relative;
      text-align: left;
      text-transform: ${theme.chameleon.button.base.textTransform};
      transition: all ease-out 300ms;
      transition-properties: background-color;
      width: fit-content;`, state !== "disabled" && `&:hover {
              background-color: ${theme.chameleon.color.VeryLightGrey};
          }`];
}}

  ${({
  variant,
  state = "unselected",
  theme
}) => variant === "no-label" ? `
      border: none;
      margin-bottom: -4px;
      padding: ${remCalc(2, theme.base)};
      ` : `
      background-color: ${theme.chameleon.button.checkbox.backgroundColor[state]};
      border: ${theme.chameleon.button.checkbox.border[state]};
      `};

  ${({
  fullWidth,
  variant,
  theme
}) => fullWidth ? `
      padding: ${theme.chameleon.button.radio.padding.fullWidth};
      margin-bottom: 8px;
      width: 100%;

      > svg {
        margin-left: ${remCalc(8, theme.base)};
      }
    ` : variant !== "no-label" && `
        flex-direction: row-reverse;
        margin-right: 8px;
        padding: ${theme.chameleon.button.radio.padding.default};

        > svg {
          margin-right: ${remCalc(8, theme.base)};
        } 
      `}
`;
const StyledInput = styled.input.attrs({
  type: "checkbox"
})`
  position: absolute;
  left: -9999px;

  ${({
  theme
}) => {
  return `
      &:focus + label {
        outline-color: ${theme.chameleon.color.Primary};
        outline-style: auto;
        outline-offset: -4px;
        outline-width: 2px;
      }
  `;
}}
`;
const Checkbox = props => {
  var _props$id, _props$id2;

  const textColor = props.state === "disabled" ? color.LightGrey : undefined;
  const {
    base
  } = useChameleonTheme();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledInput, {
    id: (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : props.label,
    onChange: props.onChange,
    checked: props.state === "selected",
    disabled: props.state === "disabled"
  }), /*#__PURE__*/React.createElement(StyledAction, {
    state: props.state,
    textColor: textColor,
    fullWidth: props.fullWidth,
    htmlFor: (_props$id2 = props.id) !== null && _props$id2 !== void 0 ? _props$id2 : props.label,
    variant: props.variant
  }, props.variant === "no-label" ? /*#__PURE__*/React.createElement(Body, {
    style: {
      width: 0,
      overflow: "hidden",
      whiteSpace: "nowrap",
      margin: 0,
      visibility: "hidden"
    }
  }, props.label) : props.label, /*#__PURE__*/React.createElement(Icon, {
    path: props.state === "selected" ? mdiCheckboxMarked : mdiCheckboxBlankOutline,
    color: props.state === "selected" ? color.Primary : color.LightGrey,
    disabled: props.state === "disabled",
    size: 24,
    style: {
      minWidth: remCalc(24, base)
    }
  })));
};

const Pill = styled.div`
  ${({
  variant,
  theme
}) => `
    background-color: ${theme.chameleon.pill[variant !== null && variant !== void 0 ? variant : "base"].backgroundColor};
    border-radius: ${theme.chameleon.pill.base.borderRadius};
    color: ${theme.chameleon.pill[variant !== null && variant !== void 0 ? variant : "base"].textColor};
    display: inline;
    max-width: fit-content;
    font-family: ${theme.chameleon.typography.base.fontFamily};
    font-size: ${theme.chameleon.pill.base.fontSize};
    font-weight: ${theme.chameleon.pill.base.fontWeight};
    margin: 0;
    padding: ${theme.chameleon.pill.base.padding};
    position: relative;
    text-transform: ${theme.chameleon.pill.base.textTransform};
  `}
`;

const StyledIconButton = styled(FlexCenter)`
  flex: none;
  height: ${({
  theme
}) => theme.chameleon.button.base.height};
  width: ${({
  theme
}) => theme.chameleon.button.base.height};
  outline-color: ${({
  theme
}) => theme.chameleon.color.Primary};

  ${({
  variant,
  theme,
  state = "active"
}) => `
  background-color: ${theme.chameleon.button[variant].backgroundColor[state]};
  border: ${theme.chameleon.button[variant].border[state]};
  border-radius: 200px;
  cursor: ${state === "active" ? "pointer" : "default"};
  transition: all ease-out 300ms;
  `}

  ${({
  state,
  theme,
  variant
}) => state === "active" && `
  &:hover {
    background-color: ${theme.chameleon.button[variant].backgroundColor.hover};
    border: ${theme.chameleon.button[variant].border.hover};
  }
  `};
`;

const getIconColor = (variant, state) => {
  if ((variant === "secondary" || variant === "warning") && state === "active") {
    return color.DarkGrey;
  }

  if (variant === "secondary" && state) {
    return color.LightGrey;
  }

  return color.White;
};

const IconButton = ({
  state = "active",
  ...props
}) => /*#__PURE__*/React.createElement(StyledIconButton, {
  variant: props.variant,
  state: state,
  disabled: state === "disabled" || state === "loading",
  "aria-label": state === "loading" ? "Loading" : undefined,
  type: props.type,
  as: "button",
  onClick: props.onClick,
  style: props.style
}, /*#__PURE__*/React.createElement(Icon, {
  path: state === "loading" ? mdiLoading : props.path,
  spin: state === "loading" && 0.5,
  size: 24,
  color: getIconColor(props.variant, state)
}));

const StyledButton$1 = styled.button`
  ${({
  theme,
  state
}) => `
    align-items: center;
    background-color: ${theme.chameleon.button.radio.backgroundColor[state]};
    border: ${theme.chameleon.button.radio.border[state]};
    border-radius: ${theme.chameleon.button.base.borderRadius};
    cursor: ${state === "disabled" ? "default" : "pointer"};
    display: flex;
    justify-content: space-between;
    margin: 0;
    outline-color: ${theme.chameleon.color.Primary};
    outline-offset: -4px;
    position: relative;
    text-align: left;
    text-transform: ${theme.chameleon.button.base.textTransform};
    transition: all ease-out 300ms;
    width: fit-content;
  `}

  ${({
  fullWidth,
  theme
}) => fullWidth ? `
    flex-direction: row-reverse;
    margin-bottom: 8px;
    padding: ${theme.chameleon.button.radio.padding.fullWidth};
    width: 100%;

    > svg {
    margin-left: ${remCalc(6, theme.base)};
  }
  ` : `
      margin-right: 8px;
      padding: ${theme.chameleon.button.radio.padding.default};

  > svg {
    margin-right: ${remCalc(6, theme.base)};
  }
  
  `}


  ${({
  state,
  theme
}) => (state === "removable" || state === "unselected" || state === "active") && `
    &:hover {
      background-color: ${theme.chameleon.button.radio.backgroundColor.hover};
    }
  `};
`;
const RadioIcon = ({
  state
}) => {
  return /*#__PURE__*/React.createElement(Icon, {
    path: state === "selected" || state === "removable" ? mdiRadioboxMarked : mdiRadioboxBlank,
    color: state === "selected" || state === "removable" ? color.Primary : color.LightGrey,
    disabled: state === "disabled",
    size: 20
  });
};

const RadioButton = ({
  state = "unselected",
  ...props
}) => {
  const textColor = state === "disabled" ? color.LightGrey : undefined;
  const {
    base
  } = useChameleonTheme();
  return /*#__PURE__*/React.createElement(StyledButton$1, {
    fullWidth: props.fullWidth,
    state: state,
    type: "button",
    onClick: props.onClick,
    style: props.style,
    "aria-selected": state === "selected",
    disabled: state === "disabled"
  }, /*#__PURE__*/React.createElement(RadioIcon, {
    state: state
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, props.fullWidth && props.avatar && /*#__PURE__*/React.createElement(Avatar, {
    user: props.avatar,
    style: {
      marginRight: remCalc(12, base),
      alignSelf: "start"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start"
    }
  }, /*#__PURE__*/React.createElement(Action, {
    textColor: textColor
  }, props.label), props.description && /*#__PURE__*/React.createElement(Body, {
    textColor: textColor,
    marginBottomSize: 0
  }, props.description))));
};

const RadioInput = styled.input`
  position: absolute;
  left: -9999px;

  ${({
  theme
}) => {
  return `
    &:focus + label {
      outline-color: ${theme.chameleon.color.Primary};
      outline-style: auto;
      outline-offset: -4px;
      outline-width: 2px;
    }
`;
}}
`;
const RadioLabel = styled.label`
  display: flex;
  gap: 0.5rem;

  ${({
  theme,
  state
}) => `
    align-items: center;
    background-color: ${theme.chameleon.button.radio.backgroundColor[state]};
    border: ${theme.chameleon.button.radio.border[state]};
    border-radius: ${theme.chameleon.button.base.borderRadius};
    cursor: ${state === "disabled" ? "default" : "pointer"};
    display: flex;
    justify-content: space-between;
    margin: 0;
    outline-color: ${theme.chameleon.color.Primary};
    outline-offset: -4px;
    position: relative;
    text-align: left;
    text-transform: ${theme.chameleon.button.base.textTransform};
    transition: all ease-out 300ms;
    width: fit-content;
    padding: ${theme.chameleon.button.radio.padding.default};
  `}
`;
const RadioWrapper = styled.div`
  margin-right: 10px;
  outline: none;
  border: none;
`;
/**
 * @description This is not exported in the main index.ts file as it is not intended for singular use. Use RadioGroup instead
 */

const Radio = props => {
  const {
    chameleon
  } = useChameleonTheme();
  const textColor = props.disabled ? chameleon.color.LightGrey : undefined;
  const state = props.checked ? "selected" : props.disabled ? "disabled" : "unselected";
  return /*#__PURE__*/React.createElement(RadioWrapper, null, /*#__PURE__*/React.createElement(RadioInput, {
    type: "radio",
    id: props.id,
    name: props.name,
    checked: props.checked,
    onChange: e => {
      props.onChange && props.onChange(e);
    },
    value: props.value,
    disabled: props.disabled
  }), /*#__PURE__*/React.createElement(RadioLabel, {
    htmlFor: props.id,
    state: state
  }, /*#__PURE__*/React.createElement(RadioIcon, {
    state: state
  }), /*#__PURE__*/React.createElement(Action, {
    textColor: textColor
  }, props.label)));
};

const FieldSet = styled.fieldset`
  border: none;
`;
const RadioWrapper$1 = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
`;
const RadioGroup = props => {
  return /*#__PURE__*/React.createElement(FieldSet, null, /*#__PURE__*/React.createElement(Headline, {
    as: "label"
  }, props.label), props.hint ? /*#__PURE__*/React.createElement(Body, null, props.hint) : null, /*#__PURE__*/React.createElement(RadioWrapper$1, null, props.radios.map(radio => /*#__PURE__*/React.createElement(Radio, {
    name: props.name,
    onChange: props.onChange,
    checked: props.value === radio.value,
    label: radio.label,
    value: radio.value,
    id: radio.value
  }))));
};

const StyledFlagContainer = styled.span`
  z-index: 10;
  display: flex;
  place-items: center;
  overflow: visible;
  margin-left: -${remCalcWithTheme(4)};
  margin-right: ${remCalcWithTheme(4)};
  max-height: ${remCalcWithTheme(18)};
`;
const StyledFlag = styled.img`
  width: ${remCalcWithTheme(28)};
  border-radius: 4px;
  overflow: hidden;
`;

const PhoneNumberInput = ({
  label,
  id,
  callingCode = "+44",
  countryCode = "GB",
  hint,
  placeholder,
  error,
  maxWidth,
  inputStyle,
  wrapperStyle,
  ...rest
}) => {
  const {
    base
  } = useChameleonTheme();
  const flagUrl = `https://assets.petsapp.com/flags/${countryCode}.svg`;
  return /*#__PURE__*/React.createElement(InputWrapper, {
    label: label,
    id: id,
    hint: hint,
    error: error,
    maxWidth: maxWidth,
    style: wrapperStyle
  }, /*#__PURE__*/React.createElement(PhoneNumberPrefix, null, /*#__PURE__*/React.createElement(StyledFlagContainer, null, /*#__PURE__*/React.createElement(StyledFlag, {
    alt: countryCode,
    src: flagUrl
  })), callingCode), /*#__PURE__*/React.createElement(InputField, _extends({
    id: id,
    error: error,
    style: {
      textIndent: `calc(${remCalc(35, base)} + ${callingCode.length}ch)`,
      ...inputStyle
    }
  }, rest)));
};

const Line = styled.hr`
  border: 0;
  border-bottom: ${({
  theme
}) => `1px solid ${theme.chameleon.color.VeryLightGrey}`};
  margin: ${({
  margin
}) => margin || `${remCalcWithTheme(8)} 0 ${remCalcWithTheme(24)}`};
  padding: 0;
  width: 100%;
`;

const Input = /*#__PURE__*/forwardRef(({
  label,
  hint,
  error,
  suffix,
  prefix,
  iconRight,
  id,
  maxWidth,
  wrapperStyle,
  inputStyle,
  ...rest
}, ref) => {
  return /*#__PURE__*/React.createElement(InputWrapper, {
    label: label,
    hint: hint,
    maxLength: rest.maxLength,
    currentLength: typeof (rest === null || rest === void 0 ? void 0 : rest.value) === "string" ? rest.value.length : undefined,
    suffix: suffix,
    prefix: prefix,
    iconRight: iconRight,
    error: error,
    id: id,
    maxWidth: maxWidth,
    style: wrapperStyle
  }, /*#__PURE__*/React.createElement(InputField, _extends({}, rest, {
    ref: ref,
    id: id,
    error: error,
    suffix: suffix,
    prefix: prefix,
    style: inputStyle
  })));
});
const TextArea = /*#__PURE__*/forwardRef(({
  label,
  hint,
  error,
  suffix,
  prefix,
  iconRight,
  id,
  maxWidth,
  wrapperStyle,
  inputStyle,
  ...rest
}, ref) => {
  return /*#__PURE__*/React.createElement(InputWrapper, {
    label: label,
    hint: hint,
    suffix: suffix,
    prefix: prefix,
    iconRight: iconRight,
    maxLength: rest.maxLength,
    currentLength: typeof (rest === null || rest === void 0 ? void 0 : rest.value) === "string" ? rest.value.length : undefined,
    error: error,
    id: id,
    maxWidth: maxWidth,
    style: wrapperStyle
  }, /*#__PURE__*/React.createElement(TextAreaField, _extends({}, rest, {
    ref: ref,
    id: id,
    error: error,
    style: inputStyle
  })));
});
const InputButton = ({
  label,
  hint,
  error,
  suffix,
  iconRight,
  id,
  placeholder,
  value,
  maxWidth,
  wrapperStyle,
  inputStyle,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(InputWrapper, {
    label: label,
    hint: hint,
    suffix: suffix,
    iconRight: iconRight,
    error: error,
    id: id,
    maxWidth: maxWidth,
    style: wrapperStyle
  }, /*#__PURE__*/React.createElement(InputFieldButton, _extends({}, rest, {
    id: id,
    error: error,
    suffix: suffix,
    style: inputStyle
  }), placeholder !== null && placeholder !== void 0 ? placeholder : value));
};

const IconContainer$1 = styled.div`
  pointer-events: none;
  grid-area: 1 / 2 / 2 / 3;
  display: flex;
  place-content: center;
  place-items: center;
  border: ${({
  theme
}) => theme.chameleon.form.input.border.default};
  background: ${({
  theme
}) => theme.chameleon.color.VeryLightGrey};
  border-top-right-radius: ${({
  theme
}) => theme.chameleon.form.input.borderRadius};
  border-bottom-right-radius: ${({
  theme
}) => theme.chameleon.form.input.borderRadius};

  ${({
  error,
  theme
}) => error && `
    border-color: ${theme.chameleon.color.DarkRed};
  `}
`;
const StyledSelect = styled.select`
  grid-area: 1 / 1 / 2 / 3;
  font-family: ${({
  theme
}) => theme.chameleon.typography.base.fontFamily};
  font-size: ${({
  theme
}) => theme.chameleon.typography.Body.fontSize};
  font-weight: ${({
  theme
}) => theme.chameleon.typography.Body.fontWeight};
  appearance: none;
  background-color: ${({
  theme
}) => theme.chameleon.color.White};
  border: ${({
  theme
}) => theme.chameleon.form.input.border.default};
  border-radius: ${({
  theme
}) => theme.chameleon.form.input.borderRadius};
  color: ${({
  theme
}) => theme.chameleon.color.DarkGrey};
  cursor: pointer;
  margin: 0;
  min-width: ${remCalcWithTheme(80)};
  max-width: 100%;
  outline-color: ${({
  theme
}) => theme.chameleon.color.Primary};
  padding: ${({
  theme
}) => theme.chameleon.form.input.padding.select};
  padding-right: ${remCalcWithTheme(48)};
  width: fill-available;

  :focus + ${IconContainer$1} {
    border: ${({
  theme
}) => theme.chameleon.form.input.border.focus};
    padding: ${({
  theme
}) => theme.chameleon.form.input.padding.selectFocus};
  }

  :focus {
    border: ${({
  theme
}) => theme.chameleon.form.input.border.focus};
    padding: ${({
  theme
}) => theme.chameleon.form.input.padding.selectFocus};
    padding-right: ${remCalcWithTheme(48)};
  }

  ${({
  disabled,
  theme
}) => disabled && `
    background-color: ${theme.chameleon.color.VeryLightGrey};
    color: ${theme.chameleon.color.Grey};
  `}

  ${({
  error,
  theme
}) => error && `
    border-color: ${theme.chameleon.color.DarkRed};
  `}

  /* smartphones, touchscreens */
  /* A catch all rule to prevent iOS devices zooming in on focus */
  @media (hover: none) and (pointer: coarse) {
    font-size: ${remCalcWithTheme(16)};
  }
`;
const SelectContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 44px;
  gap: 0;
  margin-bottom: ${remCalcWithTheme(8)};
`;
const Select = props => /*#__PURE__*/React.createElement(SelectContainer, {
  style: {
    maxWidth: props.maxWidth
  }
}, /*#__PURE__*/React.createElement(StyledSelect, {
  name: props.name,
  value: props.value,
  id: props.id,
  disabled: props.disabled,
  error: props.error,
  onClick: props.onClick,
  onChange: props.onChange
}, props.children), /*#__PURE__*/React.createElement(IconContainer$1, {
  error: props.error
}, /*#__PURE__*/React.createElement(Icon, {
  size: 18,
  path: mdiChevronDown,
  color: props.disabled ? color.Grey : undefined,
  disabled: props.disabled
})));

const SelectInputWrapper = props => /*#__PURE__*/React.createElement(StyledInputWrapper, {
  maxWidth: props.maxWidth
}, props.label ? /*#__PURE__*/React.createElement(Headline, {
  as: "label",
  htmlFor: props.id
}, props.label) : null, props.hint ? /*#__PURE__*/React.createElement(Body, {
  marginBottomSize: 1
}, props.hint) : null, props.children, props.error ? /*#__PURE__*/React.createElement(Body, {
  textColor: color.DarkRed,
  marginBottomSize: 1
}, props.error) : null);

const SelectInput = props => {
  return /*#__PURE__*/React.createElement(SelectInputWrapper, {
    label: props.label,
    id: props.id,
    hint: props.hint,
    error: props.error,
    maxWidth: props.maxWidth
  }, /*#__PURE__*/React.createElement(Select, {
    id: props.id,
    name: props.id,
    disabled: props.disabled,
    error: props.error,
    onClick: props.onClick,
    onChange: props.onChange,
    value: props.value
  }, props.children));
};

const ControlBarContainer = styled.div`
  display: flex;
  background: ${({
  theme
}) => theme.chameleon.color.VeryLightGrey};
  border: 1px solid ${({
  theme
}) => theme.chameleon.color.LightGrey};
  border-bottom-width: 0;
  border-top-left-radius: ${({
  theme
}) => theme.chameleon.form.input.borderRadius};
  border-top-right-radius: ${({
  theme
}) => theme.chameleon.form.input.borderRadius};

  *:first-child {
    border-top-left-radius: ${({
  theme
}) => theme.chameleon.form.input.borderRadius};
  }
`;
const ControlBar = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(ControlBarContainer, null, children);
};
const Control = styled.button.attrs({
  type: "button"
})`
  outline: none;
  border: none;
  display: flex;
  position: relative;
  justify-content: center;
  gap: 0.2rem;
  padding: 0.6rem 0.75rem;
  transition: all 200ms ease-in-out;
  cursor: pointer;
  background: ${({
  active,
  theme
}) => active ? theme.chameleon.color.LightGrey : "transparent"};

  &:hover {
    background: ${({
  theme
}) => theme.chameleon.color.LightGrey};
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
/**
 * A composable form component intended to enhance adding
 * templated values and emojis.
 *
 * Accepts any React children but is the intention is
 * to use `<Control />`and `<Dropdown />` components
 *
 * See the corresponding story for this component to see
 * an example using a Control and Dropdown component.
 *
 */

const ControlledTextArea = /*#__PURE__*/React.forwardRef(({
  children,
  inputStyle,
  wrapperStyle,
  label,
  hint,
  ...textAreaProps
}, ref) => {
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(InputLabelAndHint, {
    id: textAreaProps.id,
    label: label,
    hint: hint
  }), /*#__PURE__*/React.createElement(ControlBar, null, children), /*#__PURE__*/React.createElement(TextArea, _extends({}, textAreaProps, {
    ref: ref,
    wrapperStyle: wrapperStyle,
    inputStyle: { ...inputStyle,
      resize: "none",
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0
    }
  })));
});
/**
 * A composable form component intended to enhance adding
 * templated values and emojis.
 *
 * Accepts any React children but is the intention is
 * to use `<Control />`and `<Dropdown />` components
 *
 * See the corresponding story for this component to see
 * an example using a Control and Dropdown component.
 *
 */

const ControlledInput = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    children,
    inputStyle,
    wrapperStyle,
    label,
    hint,
    ...inputProps
  } = props;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(InputLabelAndHint, {
    id: inputProps.id,
    label: label,
    hint: hint
  }), /*#__PURE__*/React.createElement(ControlBar, null, children), /*#__PURE__*/React.createElement(Input, _extends({}, inputProps, {
    ref: ref,
    wrapperStyle: wrapperStyle,
    inputStyle: { ...inputStyle,
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0
    }
  })));
});

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */

var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
  "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */


var PolishedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(PolishedError, _Error);

  function PolishedError(code) {
    var _this;

    if (process.env.NODE_ENV === 'production') {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }

    return _assertThisInitialized(_this);
  }

  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }

  var normalizedColor = nameToHex(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }

  throw new PolishedError(5);
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */


var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

var reduceHexValue$1 = reduceHexValue;

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */


function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */


function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new PolishedError(7);
}

const Dot = styled.span`
  border-radius: 100%;
  display: block;
  width: 20px;
  height: 20px;
  background-color: ${({
  theme
}) => theme.chameleon.color.White};
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
`;
const Input$1 = styled.input`
  position: absolute;
  cursor: pointer;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  opacity: 0;
  width: 100%;
  margin: 0;
  padding: 0;
  z-index: 1;

  &:checked ~ ${Dot} {
    background-color: ${({
  theme
}) => theme.chameleon.color.Primary};
  }

  &:disabled ~ ${Dot} {
    background-color: ${({
  theme
}) => theme.chameleon.color.LightGrey};
  }

  &:disabled:checked ~ ${Dot} {
    background-color: ${({
  theme
}) => theme.chameleon.color.LightPrimary};
  }

  &:focus ~ ${Dot} {
    /* background-color: pink; */
  }

  &:checked:focus ~ ${Dot} {
  }
`;
const SwitchWrapper = styled.span`
  box-sizing: border-box;
  z-index: 0;
  position: relative;
  cursor: pointer;
  display: inline-flex;
  width: 58px;
  height: 38px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas: "main";
  padding: 12px;
`;
const MovingContainer = styled.span`
  position: absolute;
  top: -1px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 100%;
  cursor: pointer;
  z-index: 1;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  left: ${({
  checked
}) => checked ? "22px" : "0"};

  &:focus-within {
    background-color: ${({
  theme,
  checked
}) => checked ? rgba(theme.chameleon.color.LightPrimary, 0.3) : rgba(theme.chameleon.color.LightGrey, 0.2)};
  }
`;
const Track = styled.span`
  grid-area: main;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  width: 100%;
  height: 100%;
  z-index: -1;
  display: block;
  border-radius: 8px;
  background-color: ${({
  theme,
  checked,
  disabled
}) => {
  return checked ? disabled ? theme.chameleon.color.VeryLightPrimary : theme.chameleon.color.LightPrimary : theme.chameleon.color.VeryLightGrey;
}};
`;
const Wrapper$1 = styled.div`
  display: flex;
  align-items: center;
`;
const Label = styled(Headline)`
  cursor: pointer;
`;
const Switch = ({
  label,
  onChange,
  onClick,
  id,
  inputProps,
  disabled,
  checked
}) => {
  const {
    chameleon
  } = useChameleonTheme();
  return /*#__PURE__*/React.createElement(Wrapper$1, null, /*#__PURE__*/React.createElement(SwitchWrapper, null, /*#__PURE__*/React.createElement(MovingContainer, {
    checked: checked
  }, /*#__PURE__*/React.createElement(Input$1, _extends({}, inputProps, {
    id: id,
    disabled: disabled,
    type: "checkbox",
    checked: checked,
    onChange: onChange,
    onClick: onClick,
    name: label
  })), /*#__PURE__*/React.createElement(Dot, null)), /*#__PURE__*/React.createElement(Track, {
    checked: checked,
    disabled: disabled
  })), label ? /*#__PURE__*/React.createElement(Label, {
    as: "label",
    textColor: disabled ? chameleon.color.LightGrey : undefined,
    htmlFor: id,
    marginBottomSize: 0
  }, label) : null);
};

const HiddenSelect = styled.div`
  position: absolute;
  z-index: 100;
  display: ${({
  visible
}) => visible ? "inline-block" : "none"};
  background: ${({
  theme
}) => theme.chameleon.color.VeryLightGrey};
  border: 1px solid ${({
  theme
}) => theme.chameleon.color.LightGrey};
  border-radius: ${({
  theme
}) => theme.chameleon.button.base.borderRadius};
  left: 0;
  top: calc(100% + 2px);
  box-shadow: 0px 3px 9px 0px rgb(0 0 0 / 20%),
    0 16px 64px -32px rgb(0 0 0 / 20%);

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
`;
const TemplateItem = styled(Subhead).attrs({
  as: "li"
})`
  transition: all 200ms ease-in-out;
  display: block;
  padding: 0.5rem 1rem;

  &:hover {
    background: ${({
  theme
}) => theme.chameleon.color.LightGrey};
  }
`;
const Dropdown = ({
  items,
  onSelectItem: onSelectTemplate,
  iconSize,
  iconPath,
  title
}) => {
  const wrapper = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);

  const onClick = () => {
    setShowDropdown(prev => !prev);
  };

  useEffect(() => {
    function handleOffClick(e) {
      // @ts-ignore
      if (wrapper.current && !wrapper.current.contains(e.target)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleOffClick);
    return () => {
      document.removeEventListener("mousedown", handleOffClick);
    };
  });
  return /*#__PURE__*/React.createElement(Control, {
    onClick: onClick,
    ref: wrapper
  }, iconPath != null ? /*#__PURE__*/React.createElement(Icon, {
    size: iconSize !== null && iconSize !== void 0 ? iconSize : 16,
    path: iconPath
  }) : null, /*#__PURE__*/React.createElement(Subhead, {
    marginBottomSize: 0
  }, title), /*#__PURE__*/React.createElement(HiddenSelect, {
    visible: showDropdown
  }, /*#__PURE__*/React.createElement("ul", null, items.map(({
    label,
    value
  }) => /*#__PURE__*/React.createElement(TemplateItem, {
    key: value,
    onClick: () => {
      onSelectTemplate({
        label,
        value
      });
    },
    marginBottomSize: 0
  }, label)))));
};

const Card = styled.div`
  background-color: ${({
  variant,
  theme
}) => theme.chameleon.card[variant || "default"].backgroundColor};
  border: none;
  border-radius: ${({
  theme
}) => theme.chameleon.card.base.borderRadius};
  box-shadow: 0 8px 32px -16px rgba(0, 0, 0, 0.2),
    0 16px 64px -32px rgba(0, 0, 0, 0.2);
  padding: 0;

  ${({
  variant,
  theme
}) => variant === "outline" && `
      border-color: ${theme.chameleon.card.outline.borderColor};
      border-style: solid;
      border-width: ${theme.chameleon.card.outline.borderWidth};
      box-shadow: none;
    `};
`;

const StyledHeader = styled.header`
  display: flex;
  flex-direction: column-reverse;
  min-height: fit-content;
  padding: ${remCalcWithTheme(24)};
  max-width: 100%;
  width: fill-available;

  @media (min-width: ${media.xxsmall}) {
    align-items: start;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;
const ButtonSlot = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${remCalcWithTheme(16)};

  > button,
  div {
    margin-right: 8px;

    :last-child {
      margin-right: 0;
    }
  }

  @media (min-width: ${media.xxsmall}) {
    margin-bottom: 0;
  }
`;

const Header = props => {
  const Title = props.small ? Title2 : Title1;
  const {
    base
  } = useChameleonTheme();
  return /*#__PURE__*/React.createElement(StyledHeader, {
    style: props.style
  }, /*#__PURE__*/React.createElement(FlexRow, null, props.avatar && /*#__PURE__*/React.createElement(Avatar, {
    user: props.avatar,
    style: {
      marginRight: remCalc(16, base)
    }
  }), /*#__PURE__*/React.createElement(FlexColumn, {
    style: props.small ? {
      paddingTop: remCalc(6, base)
    } : {}
  }, /*#__PURE__*/React.createElement(Title, {
    marginBottomSize: 0.5
  }, props.title), props.description && /*#__PURE__*/React.createElement(Body, null, props.description))), /*#__PURE__*/React.createElement(ButtonSlot, null, props.buttons && props.buttons()));
};

const StyledDialogWrapper = styled(FlexCenter).withConfig({
  displayName: "dialog__StyledDialogWrapper",
  componentId: "sc-1all3kv-0"
})(["background-color:rgba(0,0,0,0.6);top:0;right:0;bottom:0;left:0;position:fixed;z-index:10;"]);

const DialogWrapper = props => {
  const handleBackdropClick = event => {
    if (event.target !== event.currentTarget) {
      return;
    }

    props.onBackgroundClick && props.onBackgroundClick();
  };

  return /*#__PURE__*/React.createElement(StyledDialogWrapper, {
    onClick: event => handleBackdropClick(event)
  }, props.children);
};

const ContentWrapper = styled.div.withConfig({
  displayName: "dialog__ContentWrapper",
  componentId: "sc-1all3kv-1"
})(["max-height:", ";overflow:auto;padding:", ";padding-bottom:", ";"], ({
  maxHeight,
  theme
}) => maxHeight || remCalc(320, theme.base), remCalcWithTheme(24), remCalcWithTheme(8));

var _StyledContentWrapper = styled(ContentWrapper).withConfig({
  displayName: "dialog___StyledContentWrapper",
  componentId: "sc-1all3kv-2"
})(["", ""], p => p._css);

const ButtonWrapper = styled(FlexColumn).withConfig({
  displayName: "dialog__ButtonWrapper",
  componentId: "sc-1all3kv-3"
})(["border-top:1px solid ", ";padding:", ";button{margin-bottom:", ";:last-child{margin-bottom:0;}}@media (min-width:", "){justify-content:flex-end;flex-direction:row;button{margin-bottom:0;margin-right:", ";:last-child{margin-right:0;}}}"], ({
  theme
}) => theme.chameleon.color.VeryLightGrey, remCalcWithTheme(24), remCalcWithTheme(8), media.xxsmall, remCalcWithTheme(8));

const Dialog = props => {
  const {
    base
  } = useChameleonTheme();
  return props.open ? /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(DialogWrapper, {
    onBackgroundClick: props.onCancel
  }, /*#__PURE__*/React.createElement(Card, {
    as: "dialog",
    open: props.open,
    style: {
      maxWidth: props.maxWidth || remCalc(400, base),
      position: "absolute",
      width: "100%",
      height: "auto"
    }
  }, /*#__PURE__*/React.createElement(Header, {
    title: props.title,
    description: props.description,
    small: true,
    style: props.content && {
      borderBottom: `1px solid ${color.VeryLightGrey}`
    },
    buttons: () => /*#__PURE__*/React.createElement(IconButton, {
      path: mdiClose,
      variant: "secondary",
      onClick: props.onCancel
    })
  }), props.content && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledContentWrapper, {
    maxHeight: props.maxHeight,
    _css: props.contentWrapperCss
  }, props.content())), props.buttons && /*#__PURE__*/React.createElement(ButtonWrapper, null, props.buttons()))), document.getElementById("chameleon-portal")) : /*#__PURE__*/React.createElement(React.Fragment, null);
};

const AccordionContent = styled.div`
  transition: opacity 400ms ease-in-out;
  overflow: hidden;

  ${({
  open,
  theme
}) => open ? `
      opacity: 1;
      margin-bottom: ${remCalc(24, theme.base)};
      ` : `
      opacity: 0;
      height: 0;
      margin-bottom: ${remCalc(0, theme.base)};
      `}
`;
const AccordionHeader = ({
  open,
  label,
  summary
}) => /*#__PURE__*/React.createElement("summary", null, /*#__PURE__*/React.createElement(Subhead, {
  textColor: color.Grey
}, label), open === false && summary != null && summary);
const AccordionItem = styled.div.attrs(() => ({
  role: "region"
}))`
  padding: 24px;
  border-bottom: 1px solid ${({
  theme
}) => theme.chameleon.color.VeryLightGrey};
`;

const Accordion = props => /*#__PURE__*/React.createElement(FlexColumn, {
  withPadding: props.withPadding
}, /*#__PURE__*/React.createElement(Header, {
  title: props.title,
  description: props.description,
  small: true,
  buttons: props.onClose ? () => /*#__PURE__*/React.createElement(IconButton, {
    onClick: props.onClose,
    path: mdiClose,
    variant: "secondary"
  }) : () => /*#__PURE__*/React.createElement("div", null),
  style: {
    borderBottom: `1px solid ${color.VeryLightGrey}`
  }
}), props.children);

const Layout = styled.div`
  display: grid;
  grid-gap: 0;
  height: 100vh;
  position: relative;

  ${({
  variant,
  theme
}) => variant === "dashboard" ? `
    grid-template-areas: "header header" "main sidebar";
    grid-template-columns: 1fr 320px;
    grid-template-rows: ${remCalc(140, theme.base)} 1fr;
    ` : variant === "chat" ? `
    grid-template-areas: "subnav main sidebar";
    grid-template-columns: 320px 1fr 320px;
    ` : `
    grid-template-areas: "main sidebar sidebar-closed";
    grid-template-columns: 1fr 240px 80px;
  `}
`;
const HeaderBar = styled(FlexRow).attrs({
  withPadding: true
})`
  align-items: baseline;
  grid-area: header;
  border-bottom: 1px solid ${({
  theme
}) => theme.chameleon.color.VeryLightGrey};
  width: fill-available;
`;
const Subnav = styled(FlexColumn).attrs({
  as: "nav"
})`
  background-color: ${({
  theme
}) => theme.chameleon.color.VeryLightGrey};
  grid-area: subnav;
`;
const StyledSidebar = styled(FlexColumn)`
  ${({
  state,
  variant
}) => state === "closed" && variant === "video" ? `grid-area: sidebar-closed;` : `grid-column-start: sidebar;
      grid-column-end: sidebar-closed;
  `}

  ${({
  variant,
  theme
}) => variant === "dashboard" ? `
        background-color: ${theme.chameleon.color.VeryLightGrey};
  ` : `
        border-left: 1px solid ${theme.chameleon.color.VeryLightGrey};
  `}
`;
const Sidebar = ({
  state = "open",
  ...props
}) => /*#__PURE__*/React.createElement(StyledSidebar, {
  as: "section",
  variant: props.variant,
  withPadding: true,
  state: state
}, props.children);
const Main = styled(FlexColumn).attrs({
  as: "main"
})`
  overflow-x: auto;

  ${({
  width
}) => width === "full" ? `
            align-items: center;
            grid-column-start: main;
            grid-column-end: sidebar;
            ` : `grid-area: main;
      `};
`;

const LOW_PRIORITY = 1; // const TRANSFORMERS = [PLACE_HOLDER_TRANSFORMER, ...DEFAULT_TRANSFORMERS];

const TRANSFORMERS = [...TRANSFORMERS$1];
const MarkdownEditorError = createGlobalStyle`
  .markdown-editor {
    border: 1px solid ${({
  theme,
  error
}) => error ? theme.chameleon.color.DarkRed : theme.chameleon.color.LightGrey};
  }
`;
const Style = createGlobalStyle`
    .markdown-editor {
        outline: 0;
        font-family: ${({
  theme
}) => theme.chameleon.typography.base.fontFamily};
        caret-color: ${({
  theme
}) => theme.chameleon.color.Primary};
        border-bottom-left-radius: ${({
  theme
}) => theme.chameleon.form.input.borderRadius};
        border-bottom-right-radius: ${({
  theme
}) => theme.chameleon.form.input.borderRadius};
        box-sizing: border-box;
        display: inline-block;
        width: 100%;
        padding: 0.5rem;
        min-height: 200px;
    }

    .editor-text-bold {
    font-weight: bold;
    }

    .editor-text-italic {
    font-style: italic;
    }

    .editor-text-underline {
    text-decoration: underline;
    }

    .editor-text-strikethrough {
    text-decoration: line-through;
    }

    .editor-text-underlineStrikethrough {
    text-decoration: underline line-through;
    }
`;
const Line$1 = styled.span`
  border-left: 1px solid ${({
  theme
}) => theme.chameleon.color.LightGrey};
  margin-left: 0.5rem;
  padding-right: 0.5rem;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
`;
const iconSize = 16;

const MarkdownControlBar = ({
  templates,
  availableBlockTypes,
  templateDropdownTitle
}) => {
  const [editor] = useLexicalComposerContext();
  const {
    chameleon
  } = useChameleonTheme();
  const [isBold, setIsBold] = useState(false);
  const [isItalic, setIsItalic] = useState(false);
  const [blockType, setBlockType] = useState();
  const [canRedo, setCanRedo] = useState(false);
  const [canUndo, setCanUndo] = useState(false);

  const setHeading = code => {
    editor.update(() => {
      const selection = $getSelection();

      if ($isRangeSelection(selection)) {
        $wrapLeafNodesInElements(selection, () => $createHeadingNode(code));
      }
    });
  };

  const setParagraph = () => {
    editor.update(() => {
      const selection = $getSelection();

      if ($isRangeSelection(selection)) {
        $wrapLeafNodesInElements(selection, () => $createParagraphNode());
      }
    });
  };

  const updateToolbar = useCallback(() => {
    const selection = $getSelection();

    if (selection != null && "anchor" in selection) {
      const anchorNode = selection.anchor.getNode();
      const element = anchorNode.getKey() === "root" ? anchorNode : anchorNode.getTopLevelElementOrThrow();
      const elementKey = element.getKey();
      const elementDOM = editor.getElementByKey(elementKey);

      if (elementDOM !== null) {
        if ($isListNode(element)) {
          const parentList = $getNearestNodeOfType(anchorNode, ListNode); // @ts-ignore

          const type = parentList ? parentList.getTag() : element.getTag();
          setBlockType(type);
        } else {
          const type = $isHeadingNode(element) ? element.getTag() : element.getType();
          setBlockType(type);
        }
      }

      if ($isRangeSelection(selection)) {
        setIsBold(selection.hasFormat("bold"));
        setIsItalic(selection.hasFormat("italic"));
      }
    }
  }, [editor]);
  useEffect(() => {
    return mergeRegister(editor.registerCommand(SELECTION_CHANGE_COMMAND, () => {
      updateToolbar();
      return false;
    }, LOW_PRIORITY), editor.registerCommand(CAN_UNDO_COMMAND, payload => {
      setCanUndo(payload);
      return false;
    }, LOW_PRIORITY), editor.registerCommand(CAN_REDO_COMMAND, payload => {
      setCanRedo(payload);
      return false;
    }, LOW_PRIORITY));
  }, [editor, updateToolbar]);

  const formatBulletList = () => {
    if (blockType !== "ul") {
      editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, null);
    } else {
      editor.dispatchCommand(REMOVE_LIST_COMMAND, null);
    }
  };

  const formatOrderedList = () => {
    if (blockType !== "ul") {
      editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, null);
    } else {
      editor.dispatchCommand(REMOVE_LIST_COMMAND, null);
    }
  };

  const onSelectTemplate = template => {
    editor.update(() => {
      const selection = $getSelection();

      if ($isRangeSelection(selection)) {
        selection.insertText(`{{${template.value}}}`);
      }
    });
  };

  return /*#__PURE__*/React.createElement(ControlBar, null, (availableBlockTypes === null || availableBlockTypes === void 0 ? void 0 : availableBlockTypes.paragraph) === false ? null : /*#__PURE__*/React.createElement(Control, {
    active: blockType === "paragraph",
    onClick: () => {
      setParagraph();
    }
  }, /*#__PURE__*/React.createElement(Subhead, {
    marginBottomSize: 0
  }, "P")), (availableBlockTypes === null || availableBlockTypes === void 0 ? void 0 : availableBlockTypes.h1) === false ? null : /*#__PURE__*/React.createElement(Control, {
    active: blockType === "h1",
    onClick: () => {
      setHeading("h1");
    }
  }, /*#__PURE__*/React.createElement(Subhead, {
    marginBottomSize: 0
  }, "H1")), (availableBlockTypes === null || availableBlockTypes === void 0 ? void 0 : availableBlockTypes.h2) === false ? null : /*#__PURE__*/React.createElement(Control, {
    active: blockType === "h2",
    onClick: () => {
      setHeading("h2");
    }
  }, /*#__PURE__*/React.createElement(Subhead, {
    marginBottomSize: 0
  }, "H2")), (availableBlockTypes === null || availableBlockTypes === void 0 ? void 0 : availableBlockTypes.h3) === false ? null : /*#__PURE__*/React.createElement(Control, {
    active: blockType === "h3",
    onClick: () => {
      setHeading("h3");
    }
  }, /*#__PURE__*/React.createElement(Subhead, {
    marginBottomSize: 0
  }, "H3")), (availableBlockTypes === null || availableBlockTypes === void 0 ? void 0 : availableBlockTypes.bold) === false ? null : /*#__PURE__*/React.createElement(Control, {
    active: isBold,
    onClick: () => {
      editor.dispatchCommand(FORMAT_TEXT_COMMAND, "bold");
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    path: mdiFormatBold
  })), (availableBlockTypes === null || availableBlockTypes === void 0 ? void 0 : availableBlockTypes.italic) === false ? null : /*#__PURE__*/React.createElement(Control, {
    active: isItalic,
    onClick: () => {
      editor.dispatchCommand(FORMAT_TEXT_COMMAND, "italic");
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    path: mdiFormatItalic
  })), (availableBlockTypes === null || availableBlockTypes === void 0 ? void 0 : availableBlockTypes.ul) === false ? null : /*#__PURE__*/React.createElement(Control, {
    onClick: formatBulletList
  }, /*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    path: mdiFormatListBulleted
  })), (availableBlockTypes === null || availableBlockTypes === void 0 ? void 0 : availableBlockTypes.ol) === false ? null : /*#__PURE__*/React.createElement(Control, {
    onClick: formatOrderedList
  }, /*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    path: mdiFormatListNumbered
  })), /*#__PURE__*/React.createElement(Line$1, null), /*#__PURE__*/React.createElement(Control, {
    onClick: () => {
      editor.dispatchCommand(UNDO_COMMAND, null);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    path: mdiUndo,
    color: canUndo ? undefined : chameleon.color.LightGrey
  })), /*#__PURE__*/React.createElement(Control, {
    onClick: () => {
      editor.dispatchCommand(REDO_COMMAND, null);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    path: mdiRedo,
    color: canRedo ? undefined : chameleon.color.LightGrey
  })), templates ? /*#__PURE__*/React.createElement(Dropdown, {
    title: templateDropdownTitle !== null && templateDropdownTitle !== void 0 ? templateDropdownTitle : "Insert dynamic value",
    iconSize: iconSize,
    iconPath: mdiLightningBolt,
    onSelectItem: onSelectTemplate,
    items: templates
  }) : null);
};

const MarkdownEditor = ({
  templates,
  onChange,
  initialMarkdown,
  onError,
  availableBlockTypes,
  editorMaxHeight,
  editorMinHeight,
  error
}) => {
  const editorConfig = {
    onError: e => {
      onError(e);
    },
    nodes: [HeadingNode, ListNode, ListItemNode, LinkNode],
    theme: {
      list: {
        nested: {
          listitem: "editor-nested-listitem"
        },
        ol: "editor-list-ol",
        ul: "editor-list-ul",
        listitem: "editor-listitem"
      },
      image: "editor-image",
      link: "editor-link",
      text: {
        bold: "editor-text-bold",
        italic: "editor-text-italic",
        underline: "editor-text-underline",
        strikethrough: "editor-text-strikethrough",
        underlineStrikethrough: "editor-text-underlineStrikethrough",
        code: "editor-text-code"
      }
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LexicalComposer, {
    initialConfig: editorConfig
  }, /*#__PURE__*/React.createElement(MarkdownControlBar, {
    availableBlockTypes: availableBlockTypes,
    templates: templates
  }), /*#__PURE__*/React.createElement(RichTextPlugin, {
    contentEditable: /*#__PURE__*/React.createElement(StyledContentEditable, {
      maxHeight: editorMaxHeight,
      minHeight: editorMinHeight,
      className: "markdown-editor"
    }),
    initialEditorState: () => {
      if (initialMarkdown) {
        $convertFromMarkdownString(initialMarkdown, TRANSFORMERS);
      }
    },
    placeholder: null
  }), /*#__PURE__*/React.createElement(Style, null), /*#__PURE__*/React.createElement(MarkdownEditorError, {
    error: error
  }), /*#__PURE__*/React.createElement(ListPlugin, null), /*#__PURE__*/React.createElement(MarkdownShortcutPlugin, null), /*#__PURE__*/React.createElement(HistoryPlugin, null), /*#__PURE__*/React.createElement(MarkdownExporter, {
    onChange: onChange
  })), error ? /*#__PURE__*/React.createElement(InputError, {
    error: error
  }) : null);
};
const StyledContentEditable = styled(ContentEditable)`
  background-color: white;
  overflow-y: auto;
  ${({
  maxHeight
}) => maxHeight ? `max-height: ${maxHeight}` : null};
  ${({
  minHeight
}) => minHeight ? `min-height: ${minHeight}` : null};
`;

const MarkdownExporter = ({
  onChange
}) => {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    const unregister = editor.registerUpdateListener(({
      editorState
    }) => {
      editorState.read(() => {
        const markdown = $convertToMarkdownString(TRANSFORMERS);
        onChange(markdown);
      });
    });
    return () => {
      unregister();
    };
  }, [onChange, editor]);
  return null;
};

export { Accordion, AccordionContent, AccordionHeader, AccordionItem, Action, Avatar, Body, Button, ButtonLink, Callout, Caption, ChameleonProvider, Checkbox, Control, ControlBar, ControlledInput, ControlledTextArea, DangerousChameleonProvider, Dialog, Display, Dropdown, FlexCenter, FlexColumn, FlexRow, Footnote, HeaderBar, Headline, Icon, IconButton, Input, InputButton, InputError, InputField, InputWrapper, Layout, Line, Main, MarkdownEditor, PhoneNumberInput, Pill, RadioButton, RadioGroup, Select, SelectInput, Sidebar, StyledSidebar, Subhead, Subnav, Switch, TextArea, Title1, Title2, color, media, remCalc, remCalcWithTheme, theme, typography, useChameleonTheme };
